export default __webpack_public_path__ + "static/media/caret-down-white.62498fb6.svg";